import { Flex, Text } from '@leverege/ui-elements'
import React from 'react'
import getReadableLabel from '../alerts/helpers/getReadableLabel'

export default function GenericTooltip( props ) {
  const {
    tooltipData : { nearestDatum },
    config,
  } = props

  return (
    <Flex variant="rowM" align="center">
      <Text variant="detailLabel">{getReadableLabel( nearestDatum.key )}</Text>
      <Text variant="detailValue">
        {config.accessors[nearestDatum.key].yAccessor( nearestDatum.datum )}
      </Text>
    </Flex>
  )
}
